import { useQuery } from "@tanstack/react-query";
import { fetchSkillsFramework } from "PFCore/services/skills_frameworks/fetch_skills_framework";
import { Id } from "PFTypes/id";
import { QueryOptions } from "PFTypes/request_options";
import { SkillsFramework } from "PFTypes/skills_framework";

import { adminSkillsFrameworksKeys } from "./query_keys";

type UseSkillsFramework = {
  id: Id;
  options?: QueryOptions<SkillsFramework>;
};

export const useSkillsFramework = ({ id, options = {} }: UseSkillsFramework) =>
  useQuery(adminSkillsFrameworksKeys.single(id), () => fetchSkillsFramework(id), options);
